export default __webpack_public_path__ + "static/media/m15.e221c28b.jpg";